import { JSX } from "react";

import { FileDownload } from "@mui/icons-material";
import { IconButton, Theme, useTheme } from "@mui/material";
import ComponentId from "src/constants/componentId.enum";
import { downloadCSVFromRows } from "src/lib/chart.helper";

const getStyles = (theme: Theme) => ({
  button: {
    borderRadius: theme.radius.xxs,
    border: 1,
    opacity: 1,
    color: theme.palette.text.secondary,
    borderColor: theme.palette.text.secondary,
    backgroundColor: theme.palette.transparent.pure,
    pointerEvents: "auto",
    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
      borderColor: theme.palette.border.subtle,
    },
  },
});

function DownloadCSV(opts: { rows: Record<string, unknown>[]; componentId: ComponentId; locationName: string }): JSX.Element | null {
  const theme = useTheme();
  return (
    <IconButton
      color='secondary'
      sx={getStyles(theme).button}
      size='small'
      disabled={!opts?.rows?.length}
      onClick={() => {
        downloadCSVFromRows(opts.rows, opts.componentId, opts.locationName);
      }}
    >
      <FileDownload />
    </IconButton>
  );
}

export default DownloadCSV;
